function _ga(...args) {
  if (window && (window as any).ga != null) {
    //@ts-ignore
    ga(...args);
  }
}

export const beacon = _ga as typeof ga;
